import { ROOT_PATH } from 'constants/paths';

function NotFoundPage(): JSX.Element {
  return (
    <div className="max-w-6xl m-auto bg-white shadow mt-8 py-32 px-14 text-center">
      <p className="text-base font-semibold text-blue-500">404</p>
      <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        Page not found
      </h1>
      <p className="mt-6 text-base leading-7 text-gray-600">
        Sorry, we couldn’t find the page you’re looking for.
      </p>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <a href={ROOT_PATH} className="btn-primary">
          Go back home
        </a>
      </div>
    </div>
  );
}

export default NotFoundPage;
